import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DateRangePicker from 'rsuite/DateRangePicker'
import { startOfDay, endOfDay, addDays, subDays } from 'date-fns'
import moment, { duration } from 'moment'
import { toast } from "react-toastify";
import AlertError from "../common/alertError";
import AlertSuccess from "../common/alertSuccess";
import {
  informationSaved,
  failed
} from "../common/misc";
import { connect } from 'react-redux'
import { useState } from "react";
import Select from "react-select";
import { generatePath } from "react-router-dom/cjs/react-router-dom.min";
import { generateReport } from "../../store/appointment";

const ReportGenerate = ({ show, onHide, generateReport }) =>  {
  const [selectedFields, setSelectedFields] = useState({
    patientName: true,
    expertName: true,
    age: false,
    email: false,
    gender: false,
    email: false,
    mobile: false,
    appointmentDate: true,
    bookingDate: false,
    fees: true,
    modeOfVisit: false,
    duration: false,
    typeOfPatient: false,
    AppointmentStatus: false,
    comments: false,
    userType: false,
  });

  const [filters, setFilters] = useState({
    dateRange: [startOfDay(new Date()), endOfDay(new Date())],
    modeOfVisit: "",
    type: "",
    appointmentCount: "",
    duration: "",
    status: "",
  });

  const fieldLabels = {
    patientName: "Patient Name",
    expertName: "Expert Name",
    age: "Age",
    gender: "Gender",
    email: "Email",
    mobile: "Mobile Number",
    appointmentDate: "Appointment Date",
    bookingDate: "Booking Date",
    fees: "Fees",
    modeOfVisit: "Mode of Visit",
    duration: "Duration",
    typeOfPatient: "Patient Type",
    AppointmentStatus: "Appointment Status",
    comments: "Comments",
    userType: "User Type",
  };

  const options = {
    modeOfVisit: [
      { value: "online", label: "Online" },
      { value: "clinic", label: "Clinic" },
    ],
    type: [
      { value: "new", label: "Fresh User" },
    ],
    appointmentCount: [
      { value: "0", label: "0 Appointments" },
      { value: "2-4", label: "2 to 4 " },
      { value: "5-7", label: "5 to 7 " },
      { value: "8-10", label: "8 to 10 " },
      { value: ">10", label: "More than 10 " },
    ],
    duration: [
      { value: 20, label: "20 mins" },
      { value: 30, label: "30 mins" },
      { value: 40, label: "40 mins" },
      { value: 50, label: "50 mins" },
      { value: 60, label: "60 mins" },
      { value: 90, label: "90 mins" },
    ],
    status: [
      { value: 1, label: "Paid" },
      { value: 2, label: "Completed" },
      { value: 3, label: "Cancelled" },
    ],
  };

  const isCreatedDateMode = !!filters.type;
  const isAppointmentCount = !!filters.appointmentCount;

  const handleDownload = () => {
    const filter = {};

    if (filters.modeOfVisit) filter.modeOfVisit = filters.modeOfVisit;
    if (filters.type) filter.type = filters.type;
    if (filters.appointmentCount) filter.appointmentCount = filters.appointmentCount;
    if (filters.duration) filter.duration = filters.duration;
    if (filters.status) filter.status = filters.status;

    if(filters.dateRange.length > 0) {
      filter.appointment_start_date = moment(
        filters.dateRange[0]
      ).format('YYYY-MM-DD')
      filter.appointment_end_date = moment(
        filters.dateRange[1]
      ).format('YYYY-MM-DD')
    }

    const fields = Object.keys(selectedFields).filter(
      (key) => selectedFields[key]
    );

    const payload = {
      fields,
      filter 
    };

    console.log("payload--> : ", payload)
    generateReport(payload, callback);
  };

  const callback = (res) => {
    if (!res) {
      toast(<AlertError message={"failed"} />);
      return;
    }

    if (res.status === 204) {
      toast(<AlertError message={"No data found"} />);
      return;
    }

    if (res.status === 200) {
      const blob = new Blob([res.data], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "appointments_report.csv");

      document.body.appendChild(link);
      link.click();
      link.remove();

      toast(<AlertSuccess message={"Report downloaded"} />);
    }
  };

  const selectAll = () => {
    const updated = {};
    Object.keys(selectedFields).forEach(k => (updated[k] = true));
    setSelectedFields(updated);
  };

  const clearAll = () => {
    const updated = {};
    Object.keys(selectedFields).forEach(k => (updated[k] = false));
    setSelectedFields(updated);
  };

  const resetFilters = () => {
    setFilters({
      dateRange: filters.dateRange,
      modeOfVisit: "",
      type: "",
      appointmentCount: "",
      duration: "",
      status: "",
    })

    setSelectedFields({
      patientName: false,
      expertName: false,
      age: false,
      email: false,
      gender: false,
      email: false,
      mobile: false,
      appointmentDate: false,
      bookingDate: false,
      fees: false,
      modeOfVisit: false,
      duration: false,
      typeOfPatient: false,
      AppointmentStatus: false,
      comments: false,
      userType: false,
    })
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Body>
        <h3 className="mb-3 ">Generate Report</h3>
        <div className="p-3 border rounded mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            <h6 className="mb-0">Select Date Range</h6>
          </div>

          <div className="report-daterange">
            <DateRangePicker
              cleanable={false}
              value={filters.dateRange}
              placement="auto"
              onChange={(value) => {
                setFilters({ ...filters, dateRange: value });
              }}
              ranges={[
                {
                  label: "Today",
                  value: [startOfDay(new Date()), endOfDay(new Date())],
                },
                {
                  label: "Yesterday",
                  value: [
                    startOfDay(addDays(new Date(), -1)),
                    endOfDay(addDays(new Date(), -1)),
                  ],
                },
                {
                  label: "Last 7 Days",
                  value: [
                    startOfDay(subDays(new Date(), 6)),
                    endOfDay(new Date()),
                  ],
                },
                {
                  label: "Last 30 Days",
                  value: [
                    startOfDay(subDays(new Date(), 30)),
                    endOfDay(new Date()),
                  ],
                },
                {
                  label: "Last One Year",
                  value: [
                    startOfDay(subDays(new Date(), 365)),
                    endOfDay(new Date()),
                  ],
                },
              ]}
            />
          </div>
        </div>

        <div className="p-3 border rounded mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0">Select Fields</h6>
            <div>
              <Button variant="link" size="sm" onClick={selectAll}>Select All</Button>
              <Button variant="link" size="sm" onClick={clearAll}>Clear All</Button>
            </div>
          </div>
          <Row>
            {Object.keys(selectedFields).map((field) => (
              <Col md={6} key={field}>
                <div className="checkbox-list mb-2">
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      disabled={isCreatedDateMode || isAppointmentCount} 
                      checked={selectedFields[field]}
                      onChange={() =>
                        setSelectedFields({
                          ...selectedFields,
                          [field]: !selectedFields[field],
                        })
                      }
                    />
                    <span></span>
                    {fieldLabels[field]}
                  </label>
                </div>
              </Col>
            ))}
          </Row>
        </div>
        
        <div className="p-3 border rounded mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Apply Filters</h6>
            <Button size="sm" variant="outline-secondary" onClick={resetFilters}>
              Reset
            </Button>
          </div>
          <Row>
            
            <Col md={6}>
              <Form.Group className="mb-3">
                <span>Created date</span>
                <Select
                  isDisabled={isAppointmentCount}
                  options={options.type}
                  value={options.type.find(opt => opt.value === filters.type) || null}
                  onChange={(val) => {
                    const value = val?.value || "";

                    setFilters({
                      dateRange: filters.dateRange,
                      type: value,
                      modeOfVisit: "",
                      appointmentCount: "",
                      duration: "",
                      status: "",
                    });

                    setSelectedFields({
                      patientName: true,
                      expertName: true,
                      age: true,
                      email: true,
                      mobile: true,
                    });
                  }}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <span>Appointment number</span>
                <Select
                  isDisabled={isCreatedDateMode }
                  options={options.appointmentCount}
                  value={options.appointmentCount.find(opt => opt.value === filters.appointmentCount) || null}
                  onChange={(val) => {
                    const value = val?.value || "";

                    setFilters({
                      dateRange: filters.dateRange,
                      type: "",
                      modeOfVisit: "",
                      appointmentCount: value,
                      duration: "",
                      status: "",
                    });

                    setSelectedFields({
                      patientName: true,
                      expertName: true,
                      age: true,
                      email: true,
                      mobile: true,
                    });
                  }}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <span>Mode of Visit</span>
                <Select
                  isDisabled={isCreatedDateMode || isAppointmentCount}
                  options={options.modeOfVisit}
                  value={options.modeOfVisit.find(opt => opt.value === filters.modeOfVisit) || null}
                  onChange={(val) =>
                    setFilters({ ...filters, modeOfVisit: val?.value || "" })
                  }
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <span>Duration</span>
                <Select
                  isDisabled={isCreatedDateMode || isAppointmentCount}
                  options={options.duration}
                  value={options.duration.find(opt => opt.value === filters.duration) || null}
                  onChange={(val) =>
                    setFilters({ ...filters, duration: val?.value || "" })
                  }
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <span>Status</span>
                <Select
                  isDisabled={isCreatedDateMode || isAppointmentCount}
                  options={options.status}
                  value={options.status.find(opt => opt.value === filters.status) || null}
                  onChange={(val) =>
                    setFilters({ ...filters, status: val?.value || "" })
                  }
                />
              </Form.Group>
            </Col>

          </Row>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={handleDownload}
        >
          Download CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const mapDispatchToProps = dispatch => ({
  generateReport: (data, callback) => dispatch(generateReport(data, callback)),
})

export default connect(null, mapDispatchToProps)(ReportGenerate)